import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'


const ButtonWithStyles = withStyles(theme => ({
  root: {
    margin: theme.spacing.unit,
    background: '#c358d4',
    fontWeight: 'bold',
    color: 'white',
    fontSize: 12,
    width: '100%',
    textAlign: 'center',
    '&:hover': {
      background: '#942ba5'
    }
  }
}))(Button)

const StdButton = props => {
  return <ButtonWithStyles
    variant='contained'
    component='span'
    {...props}
  />
}

export default StdButton